var _defs, _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#ffaacb;}.c{fill:#2edbd9;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20,
    height: 20
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20,
    height: 20
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.512 2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.482,59.957a4.725,4.725,0,0,0-1.351-3.311,3.364,3.364,0,0,0-1.361.613,3.364,3.364,0,1,1-1.361-.613,4.764,4.764,0,0,1,1.361-.973,4.741,4.741,0,1,0-2.711,8.976v.886h-.84a.682.682,0,0,0,0,1.364h.84v.84a.682.682,0,0,0,1.364,0V66.9h.84a.682.682,0,0,0,0-1.364h-.84v-.886a4.7,4.7,0,0,0,1.348-.408,4.755,4.755,0,0,0,2.711-4.284Z",
    transform: "translate(0 -53.776)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M149.487,6.645c0-.012,0-.024-.006-.036s-.005-.023-.008-.034,0-.02-.008-.03-.008-.022-.012-.033-.007-.02-.011-.029-.01-.021-.014-.031-.009-.02-.014-.029l-.018-.03-.016-.027c-.008-.012-.016-.023-.025-.034l-.015-.02c-.014-.017-.029-.034-.046-.05s-.033-.031-.05-.046l-.018-.013-.036-.026-.025-.015-.033-.019-.026-.013-.034-.016-.026-.009-.037-.013-.025-.006-.04-.01-.027,0-.039-.006-.04,0H146.66a.682.682,0,0,0,0,1.364h.507L146.14,8.451a4.738,4.738,0,0,0-6.235,7.1,3.364,3.364,0,0,0,1.361-.613,3.364,3.364,0,1,1,1.361.613,4.764,4.764,0,0,1-1.361.973A4.739,4.739,0,0,0,147.1,9.418l1.03-1.03v.507a.682.682,0,0,0,1.364,0V6.742h0c0-.023,0-.045,0-.067S149.488,6.655,149.487,6.645Z",
    transform: "translate(-134.495 -6.06)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenderIcon);
export default __webpack_public_path__ + "static/media/genderIcon.3fa3a5df052c00134482326e6002be2a.svg";
export { ForwardRef as ReactComponent };